<template>
  <CarouselCard class="insider-carousel-report-card">
    <div
      class="insider-carousel-report-card__image-container"
      @mouseover="isHoveringLock = true"
      @mouseleave="isHoveringLock = false"
    >
      <div
        :class="
          isHoveringLock
            ? 'insider-carousel-report-card__play-button-overlay insider-carousel-report-card__play-button-overlay-visible'
            : 'insider-carousel-report-card__play-button-overlay insider-carousel-report-card__play-button-overlay-hidden'
        "
        @click="$emit('report-selected', report)"
      >
        <img
          src="/images/pop-out.png"
          alt="Pop Out Button"
          class="insider-carousel-report-card__play-button-overlay-icon"
        />
      </div>
      <img
        :src="image"
        :alt="report.name"
        class="insider-carousel-report-card__image"
        @click="$emit('report-selected', report)"
      />
      <div v-if="isNew" class="insider-carousel-report-card__new-flag">NEW</div>
    </div>
    <div class="insider-carousel-report-card__button">
      <BaseButton @click="$emit('report-selected', report)">
        {{ buttonText }}
      </BaseButton>
    </div>
  </CarouselCard>
</template>

<script>
  import CarouselCard from '~/components/carousel/CarouselCard.vue';
  import IconLock from '~/components/icon/IconLock.vue';
  import IconPlayButton from '~/components/icon/IconPlayButton.vue';
  import BaseButton from '~/components/base/BaseButton.vue';

  export default {
    name: 'insider-carousel-report-card',
    components: {
      CarouselCard,
      IconLock,
      BaseButton,
      IconPlayButton,
    },
    props: {
      report: {
        type: Object,
        required: true,
      },
      image: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      isHoveringLock: false,
    }),
    mounted() {},
    computed: {
      buttonText() {
        const date = new Date(this.report.issue);
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        return `${month} ${year}`;
      },
      isNew() {
        const parsedTimeStamp = new Date(this.report.published_date);
        const currentDate = new Date();
        if (parsedTimeStamp >= currentDate) return false;
        const timeDifference = currentDate - parsedTimeStamp;
        const sevenDaysInMilliseconds = 8 * 24 * 60 * 60 * 1000;
        return timeDifference <= sevenDaysInMilliseconds;
      },
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .insider-carousel-report-card {
    width: 273px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 100%;

    &__image-container {
      object-fit: contain;
      position: relative;
    }
    &__lock-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__play-button-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__play-button-overlay-visible {
      opacity: 1;
      transition: opacity 0.2s ease-in;
    }
    &__play-button-overlay-hidden {
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }
    &__button {
      margin-top: 0.5em;
    }
    &__new-flag {
      position: absolute;
      right: -20px;
      top: 20px;
      color: #fff;
      background-color: #65a9d2;
      padding: 2px 18px;
      font-weight: 700;
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
      font-size: 20px;
      box-shadow: -4px -4px 4px rgba(0, 0, 0, 0.25);
      &::after {
        position: absolute;
        top: -20px;
        right: 0;
        content: '';
        height: 20px;
        width: 20px;
        border-bottom: solid 10px #3075a4;
        border-left: solid 10px #3075a4;
        border-right: solid 10px transparent;
        border-top: solid 10px transparent;
      }
    }
  }
</style>
